class HotIssue {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend(true, {
      wrap: null,
      data: null,
      global: window
    }, options);

    _.global = (_.option.global) ? _.option.global : window;

    _.data = null;

    _.wrap = null;
    _.listWrap = null;

    _.toggleBtn = null;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);
    if (!_.wrap || _.wrap.length <= 0) return _;

    _.listWrap = $('article ol', _.wrap);

    _.data = (_.option.data) ? _.option.data.list : [];
    if (!Array.isArray(_.data) || _.data.length <= 0) return _;

    _.toggleBtn = $('.btn-toggle', _.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    this.setList();
    this.setToggleBtn();
  }

  setList() {
    const _ = this;

    _.listWrap.empty();

    let item, obj, tpl = '';
    for (let i = 0, max = _.data.length; i < max; ++i) {
      item = _.data[i];

      obj = {
        index: i + 1,
        name: item[0],
        updown: item[1], // 'up', 'down', 'same'
        rank: item[2],
        url: `/search/index?query=${global.encodeURIComponent(item[0])}`
      };

      tpl += _.getListTpl(obj);
    }

    _.listWrap.append(tpl);
  }

  getListTpl(obj) {
    return `<li>
              <a href="${obj.url}">${obj.name}</a>
              <span class="ui-rank ${obj.updown}">${obj.rank}</span>
            </li>`;
  }

  setToggleBtn() {
    const _ = this;

    _.toggleBtn.on('click', function (evt) {
      evt.preventDefault();

      $(_.wrap).toggleClass('on');
    });
  }
}

export default HotIssue;


// WEBPACK FOOTER //
// ./_src/js/main/hotIssue/HotIssue.js